import React from 'react';
import PropTypes from 'prop-types';

export default class Countdown extends React.PureComponent {
    static propTypes = {
        start: PropTypes.number,
        end: PropTypes.number,
        children: PropTypes.func.isRequired
    };

    static defaultProps = {
        start: 3,
        end: 0
    }

    state = {
        counter: this.props.start
    }

    timer = undefined;

    UNSAFE_componentWillMount () {
        this.startCountdown();
    }

    componentWillUnmount () {
        this.stopCountdown();
    }

    startCountdown () {
        let counter = Math.floor(this.props.start);
        const countdown = () => {
            this.setState({ counter });
            if (counter > Math.floor(this.props.end)) {
                --counter;
                this.timer = setTimeout(countdown, 1000);
            } else {
                this.timer = undefined;
            }
        };

        countdown();
    }

    stopCountdown () {
        this.timer = clearTimeout(this.timer);
        this.timer = undefined;
    }

    render () {
        const { children: ChildComponent } = this.props;
        const { counter } = this.state;
        const isCounting = !!this.timer && counter > Math.floor(this.props.end);
        return <ChildComponent { ...{counter, isCounting} } />;
    }

}



// WEBPACK FOOTER //
// ./src/components/general/Countdown.js